module.exports = __webpack_public_path__ + "assets-cabinet/img/expand.4cd53dc2.svg";